import AclName from '../AclName';

export default [
  AclName.StaffAccessAll,
  AclName.FilesPageFilesList,
  AclName.BookkeepingPageDeclarationsVatList,
  AclName.BookkeepingPageDeclarationsPitList,
  AclName.BookkeepingPageZusCompanySettlementsList,
  AclName.CrmPageMyAgreementsList,
  AclName.BookkeepingInvoicesAccessAll,
  AclName.BookkeepingEvidencesAccessAll,
  AclName.ProfileEditCompanyDataTabAccess,
  AclName.ProfileViewCompanyDataCardAccess,

  AclName.CrmPageBillingList,
  AclName.CrmPageBillingSettle,
  AclName.CrmPageBankingOperationsList,
  AclName.CrmPageBankingOperationsSettle,
  AclName.FinancialSummaryView,
  AclName.MailingSettingsBtnSave,
  AclName.CrmPageMailingList,
  AclName.CrmPageMailingStepper,
  AclName.CrmBtnMailingDelete,
  AclName.CrmBtnMailingEdit,
  AclName.CrmBtnMailingSendNow,
  AclName.MailingAdmin,

  // Edycja profilu
  AclName.CanViewKsefSettings,
  AclName.CanEditKsefSettings,
  AclName.CanViewKsefPurchaseInvoicesList,
  AclName.CrmBtnClientsImport,
  AclName.StaffPageAccidentInsurancesList,
  AclName.StaffPageAccidentInsurancesEdit,
];
